import React from 'react';

const Logout = () => (
    <div>
        Logout!
    </div>
);

export default Logout;
